var map = {
	"./charity-1.png": "ca48",
	"./charity-2.png": "90fd",
	"./charity-3.png": "dc94",
	"./header.png": "aad0",
	"./icon-bee.png": "3bc3",
	"./leader-board-header.png": "c3f5",
	"./step-1.png": "82ea",
	"./step-2.png": "e320",
	"./step-3.png": "bf52",
	"./step-4.png": "650d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2f9";